import { Stack, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { PAGE_TWO_STYLES } from "../constants";
import { PageTwoFormData } from "../models";

const CatheterField = ({ label, name, isTextField, height = "auto", control, t }: { label: string; name: keyof PageTwoFormData; isTextField?: boolean; height?: string, control: any, t: any }) => (
  <Grid md={3} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <ByzMuiTypography sx={{ ...PAGE_TWO_STYLES.label, height }}>
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          isTextField ? (
            <ByzMuiTextField {...field} multiline rows={2} sx={PAGE_TWO_STYLES.textField} />
          ) : (
            <ByzMuiSelect
              {...field}
              options={[]}
              label={t("open-process-menu.select")}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              sx={PAGE_TWO_STYLES.select}
            />
          )
        )}
      />
    </Grid>
  </Grid>
);

const RadioField = ({ label, name, control, t }: { label: string; name: keyof PageTwoFormData, control: any, t: any }) => (
  <Grid md={3} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <ByzMuiTypography sx={PAGE_TWO_STYLES.label}>
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={PAGE_TWO_STYLES.gridPadding}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ByzMuiRadioButton
            {...field}
            typographyText="yes,no,unknown"
            layout="row"
            border="none"
            maxWidth="none"
            onChange={(e) => field.onChange(e.target.value)}
          />
        )}
      />
    </Grid>
  </Grid>
);

const CatheterOncologyInfo: React.FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageTwoFormData>();

  return (
    <>
      <Grid sx={PAGE_TWO_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingRight="20px" paddingTop="5px">
          {t("adult-patient-assessment.catheters")}
        </ByzMuiTypography>
      </Grid>
      
      <Stack direction="row" sx={{ padding: "0px", paddingTop: "10px" }} flexWrap="wrap">
        <CatheterField label="adult-patient-assessment.existing-catheters" name="existingCatheters" control={control} t={t} />
        <CatheterField label="adult-patient-assessment.iv-catheter-date" name="ivCatheterDate" control={control} t={t} />
        <CatheterField label="adult-patient-assessment.umbilical-catheter-date" name="umbilicalCatheterDate" control={control} t={t} />
        <CatheterField label="adult-patient-assessment.other" name="otherCatheterDesc" isTextField control={control} t={t} />
        <CatheterField label="adult-patient-assessment.family" name="familyPresenceDuringCatheter" control={control} t={t} />
      </Stack>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid sx={PAGE_TWO_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingRight="20px" paddingTop="5px">
          {t("adult-patient-assessment.oncology-patient-assessment")}
        </ByzMuiTypography>
      </Grid>

      <Stack direction="row" sx={{ padding: "0px", paddingTop: "10px" }} flexWrap="wrap">
        <CatheterField label="adult-patient-assessment.who-performance-assessment" name="whoPerformanceScore" control={control} t={t} />
        <RadioField label="adult-patient-assessment.is-informed-about-planned-treatment" name="isInformedAboutTreatment" control={control} t={t} />
        <RadioField label="adult-patient-assessment.is-informed-about-medication-rights" name="isInformedAboutMedicationRights" control={control} t={t} />
      </Stack>
    </>
  );
};

export default CatheterOncologyInfo;
